import React, { useEffect, useState, useMemo } from 'react'
import ResponsiveDrawer from '../Drawer/drawer'
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Notification from "../AlertNotification/Message";
import { TextField } from '@mui/material';
import { getProducts } from '../../ReusableComponents/functions';
import ProductCardList from '../../ReusableComponents/ProductCardList';
import { useParams, useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import debounce from 'lodash/debounce';
import IconButtonWithBadge from '../../ReusableComponents/CartIcon';
import { useOrderDraft } from './OrderDraftContext';

const SelectAProduct = () => {
    const navigate = useNavigate();
    const { customerid, name } = useParams();
    const decodedName = decodeURIComponent(name || "");

    const { draft } = useOrderDraft();
    const { cartItems } = draft;

    const drawerWidth = 200;
    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });
    const [products, setProducts] = useState([]);
    const [filterProducts, setFilterProducts] = useState([]);
    const [searchVal, setSearchVal] = useState("");

    const fetchProducts = async () => {
        const productsData = await getProducts();
        setProducts(productsData);
        setFilterProducts(productsData);
    }

    useEffect(() => {
        fetchProducts();
    }, [])

    const debouncedFilter = useMemo(() => {
        return debounce((value, allProducts) => {
            const filtered = allProducts.filter((product) =>
                (product.sku || "").toLowerCase().includes(value.toLowerCase()) ||
                (product.StyleFactory || "").toLowerCase().includes(value.toLowerCase())
            );
            setFilterProducts(filtered);
        }, 300);
    }, []);

    useEffect(() => {
        return () => {
            debouncedFilter.cancel();
        };
    }, [debouncedFilter]);

    const handleFilterProducts = (e) => {
        const val = e.target.value;
        setSearchVal(val);
        debouncedFilter(val, products);
    }
    // Calculate total pairs and price in cart for display in the layout
    const totals = React.useMemo(() => {
        let totalPairs = 0;
        let totalPrice = 0;
        cartItems.forEach(item => {
            totalPairs += item.unitQuantity;
            totalPrice += (item.unitQuantity * item.unitFinalPrice);
        });
        return { totalPairs, totalPrice };
    }, [cartItems]);

    return (
        <div className="mx-4">
            <ResponsiveDrawer heading="Select a Product - Create Order" />
            <Box
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                }}
                component="main"
            >
                <Toolbar />
                <div className="d-flex justify-content-between mx-4 mt-4">
                    <Button variant="contained" startIcon={<ArrowBackIcon />} onClick={() => navigate('/SelectCustomer')}>
                        Back
                    </Button>
                    <h4 className="fw-bold" style={{ color: '#1976d2' }}>{decodedName}</h4>
                    <div>
                        <TextField
                            id="outlined-basic"
                            label="Search By SKU"
                            size='small'
                            variant="outlined"
                            value={searchVal}
                            onChange={handleFilterProducts}
                            sx={{ width: 280 }}
                        />
                    </div>
                    <Button variant="contained" endIcon={<ArrowForwardIcon />} onClick={() => navigate('/SelectVariation')}>
                        Next
                    </Button>
                </div>
                <div className=''>
                    <ProductCardList products={filterProducts} maxHeight='80vh' />
                </div>
                {/* Floating cart icon */}
                <IconButtonWithBadge count={totals.totalPairs} />
            </Box>
            <Notification notify={notify} setNotify={setNotify} />
        </div>
    )
}

export default SelectAProduct